import { DatatablesBase } from "../base";

export default class extends DatatablesBase {
  static get orderConfig() {
    return [[0, 'desc']];
  }

  static get languageConfig() {
    return {
      "sLengthMenu": "Showing_MENU_",
      "info": "of _TOTAL_ Suggested Content Records",
      "oPaginate": {
        "sFirst": "",
        "sLast": ""
     }
    };
  }

  static get searchConfig() {
    return { searching: false }
  }

  ajaxConfig() {
    return {
      ajax: {
        url: this.table.dataset.source,
        method: 'GET'
      }
    }
  }

  static get columnConfig() {
    return [
      {
        data: 'id',
        render: (datum) => {
          return `<a href="/developers/ckeditor/suggested_contents/${datum}" target="_blank">${datum}</a>`
        }
      },
      {
        data: 'source_name'
      },
      {
        data: 'attempts'
      },
      {
        data: 'finished_at'
      },
      {
        data: 'status'
      }
    ]
  }

}
